import { AuthEnums } from "models/enums";
import useAPIClientHelper from "./useAPIClientHelper";

function useNewService() {
  const { apiClientInstance } = useAPIClientHelper();

  const getLatestArticle = () => {
    return apiClientInstance(AuthEnums.AuthType.User)
      .NewsArticlesClient.GetLatest()
      .then((res) => res.data);
  };
  return { getLatestArticle };
}

export default useNewService;
